import React from 'react';

import { AnimatePresence } from 'framer-motion';

import { TickStatus } from '../../types';

import { ColorFill, StyledStatusGradient } from './styles';

export interface StatusGradientProps {
    status?: TickStatus;
}

export function StatusGradient({ status = TickStatus.Neutral }: StatusGradientProps) {
    return (
        <StyledStatusGradient>
            <AnimatePresence>
                <ColorFill key={`StatusGradient-${status}`} $status={status} />
            </AnimatePresence>
        </StyledStatusGradient>
    );
}
